import { Link } from "react-router-dom";
import { Info } from "lucide-react";

export const EditorialDisclaimer = () => {
  return (
    <div className="flex items-start gap-3 bg-muted/50 border border-border rounded-lg p-5 my-8">
      <Info className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5" />
      <div className="text-sm text-muted-foreground">
        <p className="font-semibold text-foreground mb-1">Redaktioneller Hinweis</p>
        <p>
          Alle Inhalte auf dieser Seite wurden von unserer Redaktion unabhängig recherchiert und erstellt. 
          Wir erhalten keine Vergütung von den gelisteten Plattformen oder Anbietern. 
          Unsere Bewertungen basieren auf öffentlich zugänglichen Daten, amtlichen Quellen und eigener Marktanalyse. 
          Für weitere Informationen besuchen Sie unsere <Link to="/ueber-uns" className="text-primary hover:underline">Über-uns-Seite</Link> und 
          unsere <Link to="/datenschutz" className="text-primary hover:underline">Datenschutzerklärung</Link>.
        </p>
      </div>
    </div>
  );
};
